export enum ScriptToLoad {
	CKEDITOR = 'ckeditor'
}
